import Service from '../Components/Service.jsx'
import { useState } from 'react'
export default function Services() {
    const [Services, setServices] = useState([{ title: "Medicare Advantage plans", description: "description" },
    { title: "Medicare Supplement Plans", description: "description2" },
    { title: "Part D", description: "description3" }
        , { title: "Life Insurance", description: "description3" }
        , { title: "Individual Health Insurance", description: "description3" }
        , { title: "Commercial Insurance", description: "description3" }
        , { title: "Annuities", description: "description3" }
        , { title: "Retirement Planning", description: "description3" }])
    return (
        <div className='Services'>
            <h1>KNUDSEN INSURANCE AGENCY SPECIALIZE IN MEDICARE AND HEALTH</h1>
            <p>Finding the perfect Medicare Plan or Individual Health plan has never been
                easier.  Here at Knudsen Insurance Agency, we are on YOUR side when it
                comes to Medicare and Individual Health Insurance. We are your advocate.</p>
            <p>
                We are here to help you every step of the way on your health plan journey.
                Always keeping you up to date on any changes, as well and making sure you
                are on the best Medicare Plan for your budget and needs.</p>

            <p>
                We are here to help make choosing a Health plan much simpler. We
                understand how confusing the process can be comparing all the
                different plans. We want you to know you are not alone in this process…
                we are here to help every step of the way.</p>
            <p>
                Give Knudsen Insurance Agency a try, they provide exceptional,
                straightforward, no-hassle service that you will leave feeling like you
                finally have someone on your side with your Medicare Insurance needs.</p>
            {Services.map((service, key) => <Service key={key} text={service.title} description={service.description} />)}
            
        </div>
    );
}